export interface IAxMachine {
    /**
     * The manufacturer of the machine
     */
    manufacturer: string;
    /**
     * The machine model string
     */
    machineModel: string;
    /**
     * Commission number of the machine
     */
    commissionNumber: string;
    /**
     * (Optional) Serial number of the machine.
     * Not each machine seams to have a serial number.
     */
    serialNumber?: string;
}

export class AxMachine implements IAxMachine {
    public manufacturer: string;
    public machineModel: string;
    public commissionNumber: string;
    public serialNumber?: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IAxMachine);
    constructor(obj?: any) {
        this.manufacturer = obj && obj.manufacturer || '';
        this.machineModel = obj && obj.machineModel || '';
        this.commissionNumber = obj && obj.commissionNumber || '';
        this.serialNumber = obj && obj.serialNumber;
    }
}
